<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('jobTitle.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('jobTitle.jobTitleKh') }}</label>
              <div>
                <ts-input
                  v-model="model.job_title_kh"
                  :class="{ 'is-invalid': errors.has('job_title_kh') }"
                  autofocus
                />
                <div class="invalid-feedback" v-if="errors.has('job_title_kh')">
                  {{ errors.first('job_title_kh') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('jobTitle.jobTitleEn') }}</label>
              <div>
                <ts-input v-model="model.job_title_en" :class="{ 'is-invalid': errors.has('job_title_en') }" />
                <div class="invalid-feedback" v-if="errors.has('job_title_en')">
                  {{ errors.first('job_title_en') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
            <ts-button
              outline
              color="primary"
              class="ml-2"
              :waiting="savingAndNew"
              @click.prevent="saveAndNew"
              v-if="editData === undefined"
              >{{ $t('button.createAndNew') }}</ts-button
            >
            <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">{{
              editData ? $t('button.update') : $t('button.create')
            }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { cloneDeep } from 'lodash'

export default {
  name: 'job-title-form',
  props: ['editData'],
  data() {
    const model = {
      job_title_kh: this.editData ? this.editData.job_title_kh : '',
      job_title_en: this.editData ? this.editData.job_title_en : ''
    }

    return {
      newModel: model,
      model: cloneDeep(model),
      errors: new Errors(),
      saving: false,
      savingAndNew: false
    }
  },
  methods: {
    submit() {
      let responseResult

      this.errors = new Errors()

      if (this.editData) {
        responseResult = this.$store.dispatch('hr/jobTitle/update', {
          id: this.editData.job_title_id,
          ...this.model
        })
      } else {
        responseResult = this.$store.dispatch('hr/jobTitle/create', this.model)
      }

      return responseResult
        .then(response => {
          return this.$store.dispatch('hr/jobTitle/fetch').then(res => {
            this.saving = false
            this.$toasted.success(response.message)
            return Promise.resolve(res)
          })
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)

          return Promise.reject(error)
        })
    },
    save() {
      this.saving = true

      this.submit()
        .then(() => {
          this.$emit('close')
        })
        .finally(() => {
          this.saving = false
        })
    },
    saveAndNew() {
      this.savingAndNew = true

      this.submit()
        .then(() => {
          this.model = cloneDeep(this.newModel)
        })
        .finally(() => {
          this.savingAndNew = false
        })
    }
  }
}
</script>
